import axios, { AxiosRequestConfig } from 'axios'
import store from '@plugin/store'
import router from '@plugin/router'
import { $t } from '@plugin/i18n'

import { MessageBox, Message } from 'element-ui'
import { storage } from '@utils/index'

function showErrMessage(message: string) {
  const mes = message || 'Error'
  Message({
    message: mes,
    type: 'error',
    duration: 5 * 1000
  })
}

const showFailureBox = (function() {
  let isSHow = false
  return function() {
    if (isSHow) return
    isSHow = true
    MessageBox.confirm($t('login.confirmTip'), $t('login.confirmLogOut'), {
      confirmButtonText: $t('login.confirmBtn1'),
      cancelButtonText: $t('login.confirmBtn2'),
      type: 'warning'
    })
      .then(() => {
        storage.set('token', '')
        store.commit('app/SET_LOGIN_INFO', {})
        router.push({ name: 'Sign.Login', query: { redirect: router.currentRoute.fullPath }})
      })
      .finally(() => {
        isSHow = false
      })
  }
})()

interface HttpConfig extends AxiosRequestConfig {
  widthHeader?: boolean; // 是否携带请求头信息（默认不加）
  useFactory?: boolean; // 对返回结果进行判断（默认会判断）
  useToken?: boolean; // 在请求头中加入token（默认会加）
  loading?: boolean; // 请求是否会触发加载状态（默认会）
}

function setLoading(config: HttpConfig): void {
  if (config.url && config.loading !== false) {
    store.commit('app/ADD_LOADING', config.url)
  }
}

function removeLoading(config: HttpConfig): void {
  if (config.url && config.loading !== false) {
    store.commit('app/REMOVE_LOADING', config.url)
  }
}

// 正在响应的请求
const urls = new Map()

function http<T>(config: HttpConfig): Promise<T> {
  if (urls.has(config.url)) {
    const dataStr = config.data && JSON.stringify(config.data)
    if (dataStr === urls.get(config.url).config) return urls.get(config.url).promise
    return urls.get(config.url).promise.then(() => http(config))
  }

  const options = config

  options.baseURL = config.baseURL || process.env.VUE_APP_BASE_API
  options.method = config.method || 'POST'
  options.headers = config.headers || {}
  options.timeout = 2 * 60 * 1000

  if (config.useToken !== false) {
    config.headers['Authentication-Info'] = store.getters.token
  }

  // 设置loading
  setLoading(config)

  const promise: Promise<T> = new Promise((resolve, reject) => {
    axios(options).then(res => {
      // 取消正在挂载的状态
      urls.delete(config.url)
      // 取消loading
      removeLoading(config)

      const data = res.data
      // 直接返回
      if (options.widthHeader) {
        resolve(res as any)
      // 去掉axios携带的htpp信息
      } else if (options.useFactory === false) {
        resolve(data)
      // 成功
      } else if (data.code === '000001') {
        resolve(data.data)
      // 过期
      } else if (data.code === '000701') {
        showFailureBox()
        reject(res)
      // 失败
      } else {
        // 抛出错误信息
        showErrMessage(data.msg)
        reject(data)
      }
    }).catch(err => {
      // 取消正在挂载的状态
      urls.delete(config.url)
      // 取消loading
      removeLoading(config)
      // 抛出错误信息
      showErrMessage(err.message)
      reject(err)
    })
  })
  urls.set(config.url, { promise, config: config.data && JSON.stringify(config.data) })
  return promise
}

export default http
